import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import * as myConstList from "../Common/BaseUrl";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import Moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ProductName } from "../Common/ProductName";
import { toast } from "react-toastify";
import {
  useTradeHistoryMutation,
  useTransCurrenciesQuery,
} from "../../redux/TransactionApi";

const SpotBuyFunction = () => {
  const meta = {
    title: `Buy | Trade History | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange, Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const [showData, setShowData] = useState([]);
  const [TransactionsStatus, setTransactionsStatus] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 50,
    totalItems: 0,
  });

  const { data: currencies } = useTransCurrenciesQuery();
  const [tradeHistory] = useTradeHistoryMutation();

  // Redirect if not logged in
  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) {
      window.location.href = "/login";
    }
  }, []);

  // Auto-select first currency once currencies are loaded
  useEffect(() => {
    if (!selectedCurrency && currencies?.data?.length > 0) {
      setSelectedCurrency(currencies.data[0]);
    }
  }, [currencies]);

  // Fetch trade history whenever selectedCurrency or currentPage changes
  useEffect(() => {
    if (selectedCurrency) {
      getTradesHistory(
        selectedCurrency.symbol,
        pagination.currentPage,
        pagination.itemsPerPage
      );
    }
  }, [selectedCurrency, pagination.currentPage]);

  const getTradesHistory = async (pair = null, page = 1, limit = 10) => {
    try {
      const payload = { page, limit, side: "BUY" };
      if (pair) payload.pair = pair;

      const res = await tradeHistory(payload).unwrap();
      setShowData(res.data || []);
      setTransactionsStatus(Boolean(res?.status));
      setPagination((prev) => ({
        ...prev,
        currentPage: res.pagination?.currentPage ?? page,
        totalPages: res.pagination?.totalPages ?? 1,
        totalItems: res.pagination?.totalItems ?? 0,
        itemsPerPage: res.pagination?.itemsPerPage ?? limit,
      }));
    } catch (error) {
      setShowData([]);
      setTransactionsStatus(false);
      toast.dismiss();
      toast.error(error.data?.message || error.message);
    }
  };

  const showTableHtml = (trades) => {
    if (TransactionsStatus !== true) {
      return (
        <tbody>
          <tr>
            <td colSpan="9" className="text-center">
              No records found
            </td>
          </tr>
        </tbody>
      );
    }

    if (!trades.length) {
      return (
        <tbody>
          <tr>
            <td colSpan="9" className="text-center">
              No trades found
            </td>
          </tr>
        </tbody>
      );
    }

    const startIndex = (pagination.currentPage - 1) * pagination.itemsPerPage;
    return (
      <tbody>
        {trades.map((trade, i) => (
          <tr key={trade.id}>
            <td>{startIndex + i + 1}</td>
            <td>{trade.order_id}</td>
            <td>{trade.pair}</td>
            <td>{trade.price}</td>
            <td>{trade.quantity}</td>
            <td>{trade.commission_amount}</td>
            <td>{trade.trade_total}</td>
            <td>{trade.trade_total_with_commission}</td>
            <td>{Moment(trade.created_at).format("lll")}</td>
          </tr>
        ))}
      </tbody>
    );
  };

  const renderCoinList = () =>
    (currencies?.data || []).map((item) => (
      <li
        key={item.id}
        onClick={() => {
          setSelectedCurrency(item);
          setPagination((prev) => ({ ...prev, currentPage: 1 }));
        }}
      >
        <span className={selectedCurrency?.id === item.id ? "active" : ""}>
          {item.symbol}
        </span>
      </li>
    ));

  const renderPagination = () => {
    if (pagination.totalPages <= 1) return null;

    return (
      <div className="pagination-controls mt-3">
        <button
          className="btn"
          disabled={pagination.currentPage === 1}
          style={{ opacity: pagination.currentPage === 1 ? 0.5 : 1 }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage - 1,
            }))
          }
        >
          Prev
        </button>
        <span className="m-3">
          Page {pagination.currentPage} of {pagination.totalPages} (
          {pagination.totalItems} records)
        </span>
        <button
          className="btn"
          disabled={pagination.currentPage === pagination.totalPages}
          style={{
            opacity: pagination.currentPage === pagination.totalPages ? 0.5 : 1,
          }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage + 1,
            }))
          }
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <LoginHeader />
        <div className="bg_light">
          <div className="new_inpage">
            <div className="container container2">
              <div className="white_box">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="nav-item mb-0">Trade History</h5>

                  <div className="buyselll_box">
                    <ul className="nav buy_sell_tab">
                      <li className="nav-item">
                        <Link to="/spotBuyHistory" className="active">
                          Buy
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/spotSellHistory">Sell</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <ul className="nav nav-tabs offer_beu spot">
                  {renderCoinList()}
                </ul>

                <div className="tab-content">
                  <div className="tab-pane active" id="Balance">
                    <div className="top_balance"></div>
                    <div className="rows">
                      <div className="wallet_box">
                        <div className="table-responsive">
                          <div className="scrool_wallet_box">
                            <table className="table table-striped mb-0">
                              <thead>
                                <tr>
                                  <th>Sr. No.</th>
                                  <th>Order Id</th>
                                  <th>Pair</th>
                                  <th>Price</th>
                                  <th>Quantity</th>
                                  <th>Trade Fee</th>
                                  <th>Total</th>
                                  <th>Net Amount</th>
                                  <th>Date & Time</th>
                                </tr>
                              </thead>
                              {showTableHtml(showData)}
                            </table>
                          </div>
                        </div>
                        {renderPagination()}
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane" id="Transactions">
                    <div className="tab-content">
                      <div className="tab-pane active" id="Ledger"></div>
                      <div className="tab-pane" id="Transactions2">
                        <div className="wallet_box">
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Created</th>
                                  <th>Deposit</th>
                                  <th>Withdraw</th>
                                  <th className="tr">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Nov 20, 2020</td>
                                  <td>200</td>
                                  <td>Description</td>
                                  <td className="tr">0</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </DocumentMeta>
  );
};

export default SpotBuyFunction;
